import { Col, Input, Row, Select, message } from "antd";
import CustomButton from "../share/customButton";
import { useEffect, useState } from "react";
import { CreateInvitation } from "../../services/InvitationService";
import { Autocomplete, TextField } from "@mui/material";
import { GetAllEmptyPositions } from "../../services/PositionService";
import { useNavigate } from "react-router-dom";

interface ChildComponentProps {
  onComponentChange: () => void;
}
const PersonelInvitations: React.FC<ChildComponentProps> = ({
  onComponentChange,
}) => {
  const navigate = useNavigate();
  //CompanyInvitation State Start
  const [getData, setData] = useState<any>({
    InvitationType: 0,
  });

  const SetUnSavedDataInfo = (e: any) => {
    setData({
      ...getData,
      [e.target.id]: e.target.value,
    });

    //console.log("GetSelectedNoticeDetails", GetSelectedNoticeDetails);
  };

  //CompanyInvitation End

  const SetDataInfoManaully = (key: any, value: any) => {
    setData({
      ...getData,
      [key]: value,
    });
  };

  const [invitationButtonEnabled, SetinvitationButtonEnabled] = useState(false);
  const [getPositionsInfo, SetPositionsInfo] = useState<any>([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleOptionChange = (event: any, option: any) => {
    if (option) {
      SetDataInfoManaully("positionId", option.value);
      //formik.setFieldValue("positionId", option.id);
      setSelectedOption(option);
    }
  };
  async function CreateInvitationAsync() {
    // console.log("getData", getData);
    // console.log("getData.positionId", getData.positionId);

    if (getData.fullName === undefined || getData.fullName === "") {
      message.error("لطفا نام خانوادگی را وارد کنید");
      return;
    }
    if (getData.phoneNumber === undefined || getData.phoneNumber === "") {
      message.error("لطفا تلفن همراه را وارد کنید");
      return;
    }
    if (getData.positionId === undefined || getData.positionId === "") {
      message.error("لطفا سمت را وارد کنید");
      return;
    }
    //return;
    SetinvitationButtonEnabled(true);

    await CreateInvitation(getData).then((p) => {
      // console.log("dd", p);

      if (p.data.statusCode === 500) {
        SetinvitationButtonEnabled(false);
        message.error(p.data.message);
        return;
      }
      SetinvitationButtonEnabled(false);
      setData({
        InvitationType: 0,
        phoneNumber: "",
        fullName: "",
        companyName: "",
        positionId: "",
      });
      setSelectedOption(null);
      onComponentChange();
    });
  }

  useEffect(() => {
    GetAllEmptyPositions().then((p) => {
      console.log(p.data);
      const transformedData = p.data.map((item: any) => ({
        label: item.name,
        value: item.id,
      }));
      SetPositionsInfo(transformedData);
    });
  }, [invitationButtonEnabled]);
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const paste = e.clipboardData.getData("text");
    if (!/^\d+$/.test(paste)) {
      e.preventDefault();
    }
  };
  return (
    <>
      <div>
        <h6 className="iran">دعوتنامه جدید</h6>
        <hr />
        <Row className="display-flex align-items-center my-2">
          <Col xs={24} md={11} className="p-1">
            <Input
              id="fullName"
              onChange={SetUnSavedDataInfo}
              value={
                getData["fullName"] === undefined ? "" : getData["fullName"]
              }
              className="p-2"
              placeholder="نام و نام خانوادگی"
            />
          </Col>
          <Col xs={24} md={11} className="p-1">
            <Select
              style={{ width: "100%", height: "38px" }}
              labelRender={(p) => <>{p.label}</>}
              options={getPositionsInfo}
              onChange={handleOptionChange}
              value={selectedOption}
              notFoundContent={
                <>
                  <CustomButton
                    className="mx-1"
                    LeftIconEnabled={false}
                    RightIconEnabled={false}
                    hasTitle={true}
                    customType="Secondary"
                    customSize="Large"
                    onClick={() => {
                      navigate("/Manage/Positions");
                    }}
                  >
                    ثبت سمت جدید
                  </CustomButton>
                </>
              }
            />
          </Col>
        </Row>
        <Row className="display-flex align-items-center my-2">
          <Col xs={24} md={11} className="p-1">
            <Input
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onPaste={handlePaste}
              maxLength={11}
              minLength={11}
              id="phoneNumber"
              onChange={SetUnSavedDataInfo}
              value={
                getData["phoneNumber"] === undefined
                  ? ""
                  : getData["phoneNumber"]
              }
              className="p-2"
              placeholder="تلفن همراه"
            />
          </Col>
        </Row>

        <Row className="display-flex align-items-center my-2">
          <Col xs={24} md={11} className="p-1">
            <CustomButton
              disabled={invitationButtonEnabled}
              className="mx-1"
              LeftIconEnabled={false}
              RightIconEnabled={false}
              hasTitle={true}
              customType="Primary"
              customSize="Large"
              onClick={() => {
                CreateInvitationAsync();
              }}
            >
              ارسال
            </CustomButton>
          </Col>
        </Row>
        <div dir="rtl"></div>
      </div>
    </>
  );
};
export default PersonelInvitations;
